module.exports = __webpack_public_path__ + "static/media/UrbanColors_2_t.9c2336f6.jpg";